import React from "react";
import Select from 'react-select'

const TimeLimitSelector = props => {

  const choices = []
  choices.push({ value: '0', label: 'None' });
  for (let i=1; i<=20; i++) {
    const iStr = i.toString()
    choices.push({ value: iStr, label: iStr });
  }
  for (let i=22; i<=30; i+=2) {
    const iStr = i.toString();
    choices.push({ value: iStr, label: iStr });
  }
  for (let i=35; i<=60; i+=5) {
    const iStr = i.toString();
    choices.push({ value: iStr, label: iStr });
  }
  for (let i=70; i<=120; i+=10) {
    const iStr = i.toString();
    choices.push({ value: iStr, label: iStr });
  }

  let secondsStr = 'None'
  const seconds = props.timeLimit;
  if (seconds !== 0) {
    secondsStr = seconds.toString();
  }
  let initialValue = { value: seconds, label: secondsStr }

  return (
    <table valign="top" border="0">
      <thead><tr><th align="left">Time Limit <span className="ts-units">(seconds)</span></th></tr></thead>
      <tbody>
        <tr>
          <td>
            <Select
              className="time-limit-selector"
              defaultValue={initialValue}
              options={choices}
              onChange={selection => props.callbacks.timeLimitSetter(selection.value)}
            />
          </td>
        </tr>
      </tbody>
    </table>
  )

};

export default TimeLimitSelector;

